import { ReactComponent as SendLogo } from '../../Assets/paper-plane-top-solid.svg';
import { useConfigStore } from '../../Stores/Config';
import { useFormStore } from '../../Stores/Form';
import "./FormSendButton.scss";

function FormSendButton() {
    const formStore = useFormStore();
    const configStore = useConfigStore();

    if (formStore.currentPageCanAutoNext()) {
        return null;
    }

    return (
        <button onClick={() => {
            if (formStore.sendingForm) return;
            formStore.nextAction();
        }} type='button' aria-busy={formStore.sendingForm} className={`form-send-button ${!formStore.isCurrentStepValid() && "form-send-button--disabled"} ${formStore.sendingForm ? "form-send-button--sending" : ""}`}>
            {configStore.translateText(formStore.canAlreadySubmitForm() ? "submit" : "next")}
            {formStore.sendingForm ? <span className="form-send-spinner" aria-hidden="true" /> : <SendLogo />}
        </button>
    );
}

export default FormSendButton;
